export default __webpack_public_path__ + "static/media/aboutLogo.0294101a.svg";